import React from "react";
import { isUsOrder, UsFlagIcon } from "@/components/UsFlag";

// Shown inside the three shipping dialogs (ShipStation / Shopify / Self
// Checkout) for US destinations only. Ticked → the USMCA declaration (3 copies)
// opens when the operator confirms the shipment. Unticked by default — nothing
// prints unless the operator asks for it (user rule Oct 6, 2026).
export function UsmcaCheckbox({ order, checked, onChange, testid = "usmca-check" }) {
  if (!isUsOrder(order)) return null;
  return (
    <div className="rounded-md border border-amber-300 bg-amber-50 px-3 py-2" data-testid={`${testid}-row`}>
      <label className="flex items-start gap-2 text-sm text-amber-900 cursor-pointer">
        <input type="checkbox" checked={!!checked} onChange={(e) => onChange(e.target.checked)} className="w-4 h-4 mt-0.5 shrink-0" data-testid={testid} />
        <span><UsFlagIcon className="h-3.5 inline mr-1" /><b>Print USMCA declaration</b> (3 copies) — US customs. {checked ? "Opens when you confirm." : "Not printed unless ticked."}</span>
      </label>
    </div>
  );
}
